module.exports = __webpack_public_path__ + "assets/lessons/hr/audio/Audio 2.pdf";